export default __webpack_public_path__ + "static/media/4t.af7c588a.jpg";